import './style/App.css';
import './style/mediaquery/app.css';
import { Routes, Route, Navigate } from 'react-router-dom'
import Login from './pages/Login';
import Main from './pages/Main';
import POS from './pages/pos';
import Product from './pages/product';
import { useContext, useEffect, useState, useRef } from 'react';
import PaymentPage from './pages/payment';
import ProtectedRoute from './protected/ProtectedRoute';
import LoginEmp from './pages/logEmp';
import PermissionEmp from './protected/permissionEmp';
import Error from './pages/global/error';
import Investory from './pages/investory';
import Category from './pages/category';
import MonitorBike from './pages/MonitorBike';
import PermissionMonitorDelivery from './protected/PermissionMonitorDelivery';
import Sales from './pages/sales';
import Welcome from './pages/welcome';
import Employees from './pages/employees';
import { auth } from './context/auth';
import Settings from './pages/settings';
import Expenses from './components/empPage/expensesEmp';
import WorkForce from './components/empPage/WorkForce';
import ErrorPay from './pages/global/errorPay';
import HelpJob from './pages/global/helpJob';
import { isOnline } from './funcs/isOnline';
import { secondarySearch, showTables } from './components/indexDB/indexDBStora';
import { Asynchronous } from './funcs/async';
import { switchh } from './context/switch';
import { config } from './context/config';
import DenyPhones from './pages/denyPhones';
import { CurrentTime } from './funcs/current';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import i18n from './translator/i18next';
import Suppliers from './pages/supplier';

function App() {
  const { user, loadingUser } = useContext(auth);
  const { setTablesAreCreated, isPhone, language } = useContext(config);
  const { setLoadingProcess } = useContext(switchh);
  const { t } = useTranslation();
  const [group, setGroup] = useState(1)
  const groupRef = useRef(group);
  const isRunning = useRef(false);
  const isOnlineRef = useRef(isOnline);

  useEffect(() => {
    groupRef.current = group;
  }, [group]);

  useEffect(() => {
    isOnlineRef.current = isOnline;
  }, [isOnline]);

useEffect(() => {
  const run = async () => {
    if (!isOnlineRef.current) return;

    if (isRunning.current) return;
    isRunning.current = true;

    try {

      const currentGroup = groupRef.current;

      const productsNotAsync = await secondarySearch("products","asynchronous",'f',currentGroup,5);
      const scheduleNotAsync = await secondarySearch("schedule","asynchronous",'f',currentGroup,5);
      const InvoiceNotAsync = await secondarySearch("invoices","asynchronous",'f',currentGroup,5);
      const TransactionNotAsync = await secondarySearch("transactions","asynchronous",'f',currentGroup,5);
      
      // لو مفيش منتجات ولا schedule
      if ((!productsNotAsync || !productsNotAsync.length) &&
          (!scheduleNotAsync || !scheduleNotAsync.length) && 
          (!InvoiceNotAsync || !InvoiceNotAsync.length) && 
          (!TransactionNotAsync || !TransactionNotAsync.length)
      )
      {
        setGroup(1);
        return;
      }

      setLoadingProcess(true);

      if (productsNotAsync?.length) {
        await Asynchronous(productsNotAsync, "product");
      }

      if (scheduleNotAsync?.length) {
        await Asynchronous(scheduleNotAsync, "schedule");
      }
      if (InvoiceNotAsync?.length) {
        await Asynchronous(InvoiceNotAsync, "invoice");
      }
      if (TransactionNotAsync?.length) {
        await Asynchronous(TransactionNotAsync, "transaction");
      }

      // زيادة المجموعة
      setGroup(prev => prev + 1);

    } catch (err) {
      console.log("sync error:", err);
    } finally {
      isRunning.current = false;
      setLoadingProcess(false);
    }
  };  
  // أول تشغيل
  run();

  // interval للتشغيل كل 5 دقائق
  const interval = setInterval(run, 300000);

  return () => clearInterval(interval);

}, []);

  useEffect(() => {
    let isFinished = false
    // here i wil but the function that will run to check from expiration of subscruotion and i will sent notfication before 4 days from expiration
    const checkSubscriptionExpiration = async () => {
      const expiredDate = user?.payment?.details.expired;
      if(!expiredDate && isFinished) return;
      try {
        const expired = new Date(expiredDate);
        // we are substract one day from expired date to handle problem of add 1 day in some time zones and to make the notification appear in the right time
        expired.setDate(expired.getDate() - 1);
        const now = new Date(CurrentTime(false, true));
        const calcDiff = expired - now;
        // Implementation for checking subscription expiration
        const ExpiredAfter = Math.floor(calcDiff / (1000 * 60 * 60 * 24));
        if(ExpiredAfter <= 4 && ExpiredAfter >= 0) {
          toast.warn(
            t("common:alertExpiration", { days: ExpiredAfter }), 
            {
              position: "top-right",
              autoClose: 5000,
          });
        }
      }
      catch(err) {
        console.log("Error checking subscription expiration:", err);
      }
      finally {
        isFinished = true;
      }
    };
    checkSubscriptionExpiration()
  }, [user?.payment?.details.expired]);

  useEffect ( () => {
    const show = async () => {
        const tables = await showTables();
        setTablesAreCreated(tables);
    }
    show()
  }, [] )

  useEffect(() => {
    i18n.changeLanguage(language)
  }, [language])

  return (
    !isPhone ?
    <div className="App">
        {!loadingUser ?
        <Routes>
          <Route path='/login' element={!user || !user.data.length ? <Login /> : <Navigate to={'/'} replace />} />
          <Route path='/payment' element={<PaymentPage />} />
          <Route element={<ProtectedRoute user={user} />}>
            {/* add permission to employee who login */}
            <Route element={<LoginEmp />}>
                <Route path='/errorPay' element={<ErrorPay/>} /> 
                <Route path='/help'>
                  <Route path='jobEmp' element={<HelpJob/>} />
                </Route>
                <Route path='/' element={<Main />}>
                    <Route path='' element={<Welcome />} />
                    {/* add permission to employee cannot add in any route */}
                    <Route path='pos' element={<POS />} />
                    <Route element={<PermissionEmp />}>
                      <Route path='products' element={<Product />}>
                        <Route path='edit/:id' element></Route>
                        <Route path='scan/:id' element></Route>
                      </Route>
                      <Route path='categories' element={<Category />} />
                      <Route path='supplier' element={<Suppliers />} />
                      <Route path='investory' element={<Investory />} />
                      <Route path='employees' element={<Employees />}>
                        <Route path='exp/:username' element={<Expenses />}></Route>
                        <Route path='workTime/:username' element={<WorkForce />}></Route>
                      </Route>
                      <Route path='sales' element={<Sales />}></Route>
                      <Route path='settings' element={<Settings />}/>
                    </Route>
                    <Route element={<PermissionMonitorDelivery />}>
                      <Route path='mnbike' element={<MonitorBike />} />
                    </Route>
                </Route>
            </Route>
          </Route>
          <Route path='*' element={<Error />}></Route>
        </Routes>
        :
        null
        }
    </div>
    :
    <DenyPhones />
  );
}

export default App;
